import { generateJson } from './generate-json';

const generateFormJs = (form, framework) => {
  const json = generateJson(form, framework);
  return `const form = ${json};
export { form };`;
};

export { generateFormJs };
